module.exports = __webpack_public_path__ + "img/contest_element.29a99500.png";